
import * as React from "react";
import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel } from '../uicomponent';
import { CheckboxProps, CheckboxState, CheckboxHandler } from './checkboxcomponent';
import { CheckboxCSSStyleImpl } from './checkboxcss';


export class CheckboxView extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onClick = this.onClick.bind(this);
    }

    draw(uiProps: CheckboxProps, uiState: CheckboxState, cssStyle: CheckboxCSSStyleImpl): JSX.Element | boolean
    {
        super.draw(uiProps, uiState, cssStyle);

            if(uiState.isChecked)
            {
                return(
                    <div style={cssStyle.getCSSStyleOne()} onClick={this.onClick}>
                        <div style={cssStyle.getCSSStyleTwo()}/>
                    </div>
                ); 
            }
            return <div style={cssStyle.getCSSStyleThree()} onClick={this.onClick}/>;
    }

    onClick(): void 
    {
        (this.getUIComponentHandler() as CheckboxHandler).onClick();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/checkbox/checkboxview.tsx